import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ImportPayload } from "src/app/_models/Import/ImportModel";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";
import { Guid } from "guid-typescript";
import { ImportConstants } from "src/app/constants/ImportConstants";
@Injectable({
  providedIn: "root",
})
export class ImportLearnerService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private publicBaseUrl: string = this.config.publicBaseUrl;
  private static readonly IMPORT_PATH: string = "Import/";
  private static readonly SSE_PATH: string = "PublicSSE/";
  private static readonly IMPORT_LEARNER_CSV: string = "learner/";
  private static readonly IMPORT_STATUS: string = "status?subjectId=";
  private static readonly IMPORT_AUTH: string = "authorize";
  private static readonly IMPORT_DL_ERROR_LIST: string = "errorlist";
  private static readonly IMPORT_HAS_IMPORTS: string = "has-import";
  private static readonly IMPORT_CLEAR_SESSION: string = "clear-import";
  private static readonly IMPORT_CANCEL: string = "cancel";
  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private http: HttpClient
  ) {}

  public hasImport$(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}${ImportLearnerService.IMPORT_PATH}${ImportLearnerService.IMPORT_HAS_IMPORTS}`);
  }

  public uploadCSVFile$(payload: ImportPayload): Observable<boolean> {
    let params = new HttpParams();
    if (payload?.options) {
      payload.options.forEach((option) => {
        params = params.append(ImportConstants.OPTION, option);
      });
    }

    return this.http.post<boolean>(`${this.baseUrl}${ImportLearnerService.IMPORT_PATH}${ImportLearnerService.IMPORT_LEARNER_CSV}${payload.mode}`,
      payload.file, {params}
    );
  }

  public authorizeSSERequest$(): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}${ImportLearnerService.IMPORT_PATH}${ImportLearnerService.IMPORT_AUTH}`, {});
  }

  public downloadErrorList$(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}${ImportLearnerService.IMPORT_PATH}${ImportLearnerService.IMPORT_DL_ERROR_LIST}`);
  }

  public getStatusStream(subjectId: Guid): EventSource {
    return new EventSource(`${this.publicBaseUrl}${ImportLearnerService.SSE_PATH}${ImportLearnerService.IMPORT_STATUS}${subjectId}`);
  }

  public clearImportSession$(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}${ImportLearnerService.IMPORT_PATH}${ImportLearnerService.IMPORT_CLEAR_SESSION}`);
  }

  public cancelImport$(): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}${ImportLearnerService.IMPORT_PATH}${ImportLearnerService.IMPORT_CANCEL}`, {});
  }
}
